import React, { useState, memo } from 'react';
import { BookOpen, Users, Award } from 'lucide-react';
const TipsPage = () => {
  const [activeTab, setActiveTab] = useState('theory');
  return <div className="bg-white" data-id="element-1882" data-mp="gr7seubh8muj">
      <div className="container mx-auto px-4 py-12" data-id="element-1883" data-mp="1wt9suvtrfge">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1884" data-mp="1ye2sg2hqqc5">Driving Tips</h1>
        <p className="text-gray-700 mb-8" data-id="element-1885" data-mp="6ttcqwxdo23a">
          Whether you're preparing for your theory test, just passed your
          practical test, or have been driving for years, we've compiled some
          useful tips to help you become a safer and more confident driver.
        </p>
        {/* Tabs */}
        <div className="flex flex-wrap border-b border-gray-200 mb-8" data-id="element-1886" data-mp="3fcr6szr2dlno">
          <button className={`mr-4 py-2 px-4 font-medium rounded-t-lg ${activeTab === 'theory' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('theory')} data-id="element-1887" data-mp="3k9hi79rxbt2r">
            <div className="flex items-center" data-id="element-1888" data-mp="3ae7fskxm5jog">
              <BookOpen size={18} className="mr-2" data-id="element-1889" data-mp="ys2ts6e9nap" />
              Theory Test Tips
            </div>
          </button>
          <button className={`mr-4 py-2 px-4 font-medium rounded-t-lg ${activeTab === 'new' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('new')} data-id="element-1890" data-mp="3s52y17oq3tu4">
            <div className="flex items-center" data-id="element-1891" data-mp="5wti020p92gw">
              <Users size={18} className="mr-2" data-id="element-1892" data-mp="3efix87epd6ng" />
              New Drivers Tips
            </div>
          </button>
          <button className={`py-2 px-4 font-medium rounded-t-lg ${activeTab === 'experienced' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('experienced')} data-id="element-1893" data-mp="39gy04guqz338">
            <div className="flex items-center" data-id="element-1894" data-mp="2vnq4me3jpng9">
              <Award size={18} className="mr-2" data-id="element-1895" data-mp="2vmf0gd66udom" />
              Experienced Drivers Tips
            </div>
          </button>
        </div>
        {/* Content */}
        <div className="mb-12" data-id="element-1896" data-mp="3gdu46zjk1kms">
          {activeTab === 'theory' && <div data-id="element-1897" data-mp="3kemdttwc9rjl">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1898" data-mp="3ke4723c1vuxf">Theory Test Tips</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1899" data-mp="3p5cif4wxxqd8">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1900" data-mp="3p64cgbaw3g1e">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-1901" data-mp="3u3e13oqgfno6">
                    Multiple Choice Questions
                  </h3>
                  <ul className="space-y-2" data-id="element-1902" data-mp="2xfzndzc6q4tu">
                    <li className="flex items-start" data-id="element-1903" data-mp="31f8fz0vhnwnt">
                      <div className="text-burgundy-600 mr-2" data-id="element-1904" data-mp="31g1puapqv2a6">•</div>
                      <div data-id="element-1905" data-mp="36dtf0wz08aao">
                        Study the Highway Code thoroughly - it forms the basis
                        of many questions.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1906" data-mp="lnko3jvc0ubv">
                      <div className="text-burgundy-600 mr-2" data-id="element-1907" data-mp="qnqeyxts2csw">•</div>
                      <div data-id="element-1908" data-mp="qlvwdq5zawrz">
                        Use official DVSA practice materials and apps to
                        familiarise yourself with the question format.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1909" data-mp="21fy911b9v91j">
                      <div className="text-burgundy-600 mr-2" data-id="element-1910" data-mp="21en3avy9nr7s">•</div>
                      <div data-id="element-1911" data-mp="1whemayoutt84">
                        Create a study schedule and stick to it - consistent
                        practice is key.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1912" data-mp="1nfnftrmhpid7">
                      <div className="text-burgundy-600 mr-2" data-id="element-1913" data-mp="1ni9o5th7g1wh">•</div>
                      <div data-id="element-1914" data-mp="1ihve65w1mhvt">
                        Focus on traffic signs and road markings, as these
                        frequently appear in the test.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1915" data-mp="3cul8upu8jv49">
                      <div className="text-burgundy-600 mr-2" data-id="element-1916" data-mp="37wa1clrexwp7">•</div>
                      <div data-id="element-1917" data-mp="37txm4gd1i0fu">
                        Don't just memorise answers - understand the reasoning
                        behind them.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1918" data-mp="35z1ww6pympry">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-1919" data-mp="360wg9gll29tx">
                    Hazard Perception
                  </h3>
                  <ul className="space-y-2" data-id="element-1920" data-mp="2x6i1rg8vn3bv">
                    <li className="flex items-start" data-id="element-1921" data-mp="2x4nh831ipd8b">
                      <div className="text-burgundy-600 mr-2" data-id="element-1922" data-mp="31worjjf4ktvp">•</div>
                      <div data-id="element-1923" data-mp="31z1gwhn7q6is">
                        Practise spotting developing hazards - click when you
                        first see a potential danger.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1924" data-mp="2e7cicjjsslte">
                      <div className="text-burgundy-600 mr-2" data-id="element-1925" data-mp="2e8nkyg1ibnix">•</div>
                      <div data-id="element-1926" data-mp="2i9h8v9ey92bt">
                        Avoid clicking too many times in quick succession, as
                        this can be flagged as cheating.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1927" data-mp="1umm3a6rbwrga">
                      <div className="text-burgundy-600 mr-2" data-id="element-1928" data-mp="1unx2rudqrd1l">•</div>
                      <div data-id="element-1929" data-mp="28mwrf2197rxr">
                        Look for clues like pedestrians near the road, children
                        playing, or vehicles signalling.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1930" data-mp="2ihezejdpe9nd">
                      <div className="text-burgundy-600 mr-2" data-id="element-1931" data-mp="2djdio53r2mf2">•</div>
                      <div data-id="element-1932" data-mp="2rblcpp3nfza2">
                        Remember that each clip contains at least one developing
                        hazard.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1933" data-mp="31a0u30cvju6d">
                      <div className="text-burgundy-600 mr-2" data-id="element-1934" data-mp="31aiw6dm7x2m7">•</div>
                      <div data-id="element-1935" data-mp="2wbpiol6xlbm1">
                        Use official DVSA hazard perception practice tests to
                        get familiar with the format.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1936" data-mp="22y6n2jf7vuhj">
                <h3 className="text-xl font-semibold mb-3" data-id="element-1937" data-mp="22wn7kv1dxngt">On Test Day</h3>
                <ul className="space-y-2" data-id="element-1938" data-mp="27pydmtydi07o">
                  <li className="flex items-start" data-id="element-1939" data-mp="27qzniv3nkgnt">
                    <div className="text-burgundy-600 mr-2" data-id="element-1940" data-mp="2cmy9kc1idml2">•</div>
                    <div data-id="element-1941" data-mp="2hmudkba7he0m">Get a good night's sleep before your test.</div>
                  </li>
                  <li className="flex items-start" data-id="element-1942" data-mp="2loo9k69ghtug">
                    <div className="text-burgundy-600 mr-2" data-id="element-1943" data-mp="2lp7iixh4p7wc">•</div>
                    <div data-id="element-1944" data-mp="2qoam0dhgn627">
                      Arrive at the test centre at least 15 minutes early with
                      your provisional licence and booking reference.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1945" data-mp="waj5qv4mlnxs">
                    <div className="text-burgundy-600 mr-2" data-id="element-1946" data-mp="oq8loyj0n4rj">•</div>
                    <div data-id="element-1947" data-mp="orjpuzgdiej6">
                      Read each question carefully and consider all options
                      before answering.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1948" data-mp="f0yqvawsf7zq">
                    <div className="text-burgundy-600 mr-2" data-id="element-1949" data-mp="a1m3mp207ywm">•</div>
                    <div data-id="element-1950" data-mp="9z9i61x1f6et">
                      If you're unsure about a question, flag it and return to
                      it later.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1951" data-mp="12qt3brd72ujg">
                    <div className="text-burgundy-600 mr-2" data-id="element-1952" data-mp="xqdqd0wtrp20">•</div>
                    <div data-id="element-1953" data-mp="xsro5hiw3fd9">
                      Manage your time carefully - you have 57 minutes for the
                      multiple-choice section.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
          {activeTab === 'new' && <div data-id="element-1954" data-mp="1hewm4oyxfmxl">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1955" data-mp="1heete2bh3quf">New Drivers Tips</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1956" data-mp="1hh9c9peu93lq">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1957" data-mp="1mfaxafvtrczu">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-1958" data-mp="18f061bqlrwe5">
                    Building Confidence
                  </h3>
                  <ul className="space-y-2" data-id="element-1959" data-mp="1dduvuxmzml7r">
                    <li className="flex items-start" data-id="element-1960" data-mp="212w16c0ixg8t">
                      <div className="text-burgundy-600 mr-2" data-id="element-1961" data-mp="213ffliqytmi3">•</div>
                      <div data-id="element-1962" data-mp="254qzd7n5rdid">
                        Start with short, familiar journeys to build your
                        confidence gradually.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1963" data-mp="1wbdvjank2rhi">
                      <div className="text-burgundy-600 mr-2" data-id="element-1964" data-mp="1w9uehhu2sceo">•</div>
                      <div data-id="element-1965" data-mp="2k06wxmmy5rji">
                        Drive during daylight and good weather conditions
                        initially.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1966" data-mp="2y5z36nr4jxwk">
                      <div className="text-burgundy-600 mr-2" data-id="element-1967" data-mp="2u5opsq10657o">•</div>
                      <div data-id="element-1968" data-mp="2u5gc4vx22vvf">
                        Consider taking a Pass Plus course to develop your
                        skills further.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1969" data-mp="32ys759err27l">
                      <div className="text-burgundy-600 mr-2" data-id="element-1970" data-mp="2f7nv1zbv1zf4">•</div>
                      <div data-id="element-1971" data-mp="2b6u755yf4km8">
                        Drive solo to develop your own decision-making
                        abilities.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1972" data-mp="2p4issg0b7vsc">
                      <div className="text-burgundy-600 mr-2" data-id="element-1973" data-mp="2k6h9pv2vvwgv">•</div>
                      <div data-id="element-1974" data-mp="4g4hq2t1xhqr">
                        Remember that building confidence takes time - don't
                        rush yourself.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1975" data-mp="34796umm7it3d">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-1976" data-mp="2z9r7nnxzrs8k">Safety First</h3>
                  <ul className="space-y-2" data-id="element-1977" data-mp="2zbtvq2fl3ban">
                    <li className="flex items-start" data-id="element-1978" data-mp="2uhplnab0un5c">
                      <div className="text-burgundy-600 mr-2" data-id="element-1979" data-mp="2ugejtg14zpgv">•</div>
                      <div data-id="element-1980" data-mp="2pj4v62lknhu3">
                        Always adjust your mirrors and seat before setting off.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1981" data-mp="2gigf72cmb7ek">
                      <div className="text-burgundy-600 mr-2" data-id="element-1982" data-mp="2gl2qnd2mq722">•</div>
                      <div data-id="element-1983" data-mp="2bkognphgwn1e">
                        Avoid distractions - set up your navigation and music
                        before starting your journey.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1984" data-mp="9s0ab79j1jhe">
                      <div className="text-burgundy-600 mr-2" data-id="element-1985" data-mp="4sxfefn9gtn5">•</div>
                      <div data-id="element-1986" data-mp="4rmb8epwljvi">
                        Never use your phone while driving - it's illegal and
                        dangerous.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1987" data-mp="h9ydku147yc6">
                      <div className="text-burgundy-600 mr-2" data-id="element-1988" data-mp="m3suxqt90183">•</div>
                      <div data-id="element-1989" data-mp="r1kzplezrhtp">
                        Be aware of the New Driver Act - you'll lose your
                        licence if you get 6 points within 2 years of passing.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1990" data-mp="3ujmb24jo3aom">
                      <div className="text-burgundy-600 mr-2" data-id="element-1991" data-mp="3c9t3naymt7n">•</div>
                      <div data-id="element-1992" data-mp="3ayoxmdlrjg0">
                        Leave plenty of space between you and the vehicle in
                        front.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1993" data-mp="1jq0a1un6hbyp">
                <h3 className="text-xl font-semibold mb-3" data-id="element-1994" data-mp="1jsmgts28vnfv">Practical Advice</h3>
                <ul className="space-y-2" data-id="element-1995" data-mp="u0t8xyqedqoy">
                  <li className="flex items-start" data-id="element-1996" data-mp="p3jm8que7t4t">
                    <div className="text-burgundy-600 mr-2" data-id="element-1997" data-mp="p2rnx89evhau">•</div>
                    <div data-id="element-1998" data-mp="140tu7q7tugvs">
                      Learn basic car maintenance like checking oil, water, and
                      tyre pressure.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1999" data-mp="bbd7n96w1u7h">
                    <div className="text-burgundy-600 mr-2" data-id="element-2000" data-mp="bc67dq7fjjg4">•</div>
                    <div data-id="element-2001" data-mp="6dutn4e0kosm">
                      Consider taking a motorway driving lesson with an
                      instructor, as this isn't covered in the standard test.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2002" data-mp="g9ofjedmhun2">
                    <div className="text-burgundy-600 mr-2" data-id="element-2003" data-mp="3oq9f64kd7bdi">•</div>
                    <div data-id="element-2004" data-mp="3oog84o5uap4z">
                      Plan unfamiliar journeys in advance and allow extra time.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2005" data-mp="1z8m9xtftoiaa">
                    <div className="text-burgundy-600 mr-2" data-id="element-2006" data-mp="240dsphsqljpv">•</div>
                    <div data-id="element-2007" data-mp="241owviq3gthi">
                      Keep a small emergency kit in your car (torch, blanket,
                      water, etc.).
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2008" data-mp="1ubccbqia50bd">
                    <div className="text-burgundy-600 mr-2" data-id="element-2009" data-mp="2i0euczgtsv6e">•</div>
                    <div data-id="element-2010" data-mp="2hy2f4u2gcyx1">
                      Shop around for insurance - consider black box policies
                      which can reduce premiums for safe driving.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
          {activeTab === 'experienced' && <div data-id="element-2011" data-mp="xkjxew731eb6">
              <h2 className="text-2xl font-bold mb-4" data-id="element-2012" data-mp="xk23453zda5w">
                Experienced Drivers Tips
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-2013" data-mp="11myilmy84q5m">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2014" data-mp="1htjts5czt0hp">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2015" data-mp="1hv4j9gkg9t8p">
                    Refreshing Your Skills
                  </h3>
                  <ul className="space-y-2" data-id="element-2016" data-mp="182yu0ell1px7">
                    <li className="flex items-start" data-id="element-2017" data-mp="183rsksae1949">
                      <div className="text-burgundy-600 mr-2" data-id="element-2018" data-mp="134nm49eulphm">•</div>
                      <div data-id="element-2019" data-mp="132auf4jag0rd">
                        Consider a refresher lesson if you haven't driven for a
                        while.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2020" data-mp="1vqq6pjb1c4z0">
                      <div className="text-burgundy-600 mr-2" data-id="element-2021" data-mp="1qsydmlynmct8">•</div>
                      <div data-id="element-2022" data-mp="1ms4ppsl7oy0c">
                        Stay updated with changes to the Highway Code - they
                        happen more often than you might think.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2023" data-mp="bcpx1101csb1">
                      <div className="text-burgundy-600 mr-2" data-id="element-2024" data-mp="bf2d18m8gslg">•</div>
                      <div data-id="element-2025" data-mp="2n1m9gri0ictf">
                        Practise advanced manoeuvres like parallel parking in a
                        quiet area if you're rusty.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2026" data-mp="2vzg3fvsb0udf">
                      <div className="text-burgundy-600 mr-2" data-id="element-2027" data-mp="30s9c2uqw8mus">•</div>
                      <div data-id="element-2028" data-mp="30tkg8vo93wmf">
                        Consider an advanced driving course like IAM RoadSmart
                        or RoSPA.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2029" data-mp="3as032mg8wjq4">
                      <div className="text-burgundy-600 mr-2" data-id="element-2030" data-mp="3esk4w3brkbil">•</div>
                      <div data-id="element-2031" data-mp="3jqbsil5dlbgz">
                        Regularly check for bad habits that may have crept into
                        your driving style.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2032" data-mp="1pd2rlhqwayac">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2033" data-mp="2smyi2kpw4zb6">
                    Defensive Driving
                  </h3>
                  <ul className="space-y-2" data-id="element-2034" data-mp="2npf13d1t68fj">
                    <li className="flex items-start" data-id="element-2035" data-mp="2nqq7zlqjvwav">
                      <div className="text-burgundy-600 mr-2" data-id="element-2036" data-mp="31oxzvf8qc7f6">•</div>
                      <div data-id="element-2037" data-mp="2wok2cr4r8fve">
                        Anticipate other road users' actions - expect the
                        unexpected.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2038" data-mp="36nhlfejevh70">
                      <div className="text-burgundy-600 mr-2" data-id="element-2039" data-mp="36mpzkvfm8xtx">•</div>
                      <div data-id="element-2040" data-mp="3kew9hzs6e8kx">
                        Maintain a safe following distance (at least 2 seconds,
                        more in poor conditions).
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2041" data-mp="3udlpto4fbkz2">
                      <div className="text-burgundy-600 mr-2" data-id="element-2042" data-mp="3pdr19r84f7h6">•</div>
                      <div data-id="element-2043" data-mp="3pfk6r36zzlnl">
                        Regularly check your mirrors and be aware of your blind
                        spots.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2044" data-mp="hspu3fpxo9cr">
                      <div className="text-burgundy-600 mr-2" data-id="element-2045" data-mp="2wgvmgdva01e">•</div>
                      <div data-id="element-2046" data-mp="2ybezq9hpk3d">
                        Stay calm in challenging situations - road rage helps no
                        one.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2047" data-mp="3q6yew1m7rvud">
                      <div className="text-burgundy-600 mr-2" data-id="element-2048" data-mp="3v0t5lp08lb2y">•</div>
                      <div data-id="element-2049" data-mp="3gb3pmnnhj2im">
                        Always have an escape route planned in case of
                        emergency.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2050" data-mp="37ap2rjuvhfd0">
                <h3 className="text-xl font-semibold mb-3" data-id="element-2051" data-mp="3bcaayrwgp5gv">
                  Long-Term Driving Health
                </h3>
                <ul className="space-y-2" data-id="element-2052" data-mp="3rq8fakcmkq7e">
                  <li className="flex items-start" data-id="element-2053" data-mp="3roxaqibcvef8">
                    <div className="text-burgundy-600 mr-2" data-id="element-2054" data-mp="3mt8989frznga">•</div>
                    <div data-id="element-2055" data-mp="3hstwwf755rcg">
                      Have regular eye tests to ensure your vision meets driving
                      standards.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2056" data-mp="38sfa1bej446u">
                    <div className="text-burgundy-600 mr-2" data-id="element-2057" data-mp="38t760nc1g3xn">•</div>
                    <div data-id="element-2058" data-mp="3415nwks6vizp">
                      Take breaks on long journeys - at least 15 minutes every
                      two hours.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2059" data-mp="2u3rirhbpugmp">
                    <div className="text-burgundy-600 mr-2" data-id="element-2060" data-mp="2u52npkgwdufe">•</div>
                    <div data-id="element-2061" data-mp="2p4obdq89jybk">
                      Maintain good posture while driving to prevent back
                      problems.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2062" data-mp="10l2byipsazec">
                    <div className="text-burgundy-600 mr-2" data-id="element-2063" data-mp="10k90j4fvrlpv">•</div>
                    <div data-id="element-2064" data-mp="14lm8bk2j9yzf">
                      Consider eco-driving techniques to save fuel and reduce
                      environmental impact.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2065" data-mp="1ektla65cvrm0">
                    <div className="text-burgundy-600 mr-2" data-id="element-2066" data-mp="1eih4hwbc3naj">•</div>
                    <div data-id="element-2067" data-mp="gy4bha4ewapl">
                      Keep your vehicle well-maintained with regular servicing.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
        </div>
        <div className="text-center" data-id="element-2068" data-mp="qswdqr8xvlqp">
          <h2 className="text-2xl font-bold mb-4" data-id="element-2069" data-mp="vm7gohamridc">
            Need More Specific Advice?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-2070" data-mp="3uchfhtszj614">
            Our instructors are always happy to provide personalised tips and
            guidance. Whether you're preparing for your test or looking to
            improve specific driving skills, we're here to help.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-2071" data-mp="3c6n6a71fq4uv">
            Contact Us
          </a>
        </div>
      </div>
    </div>;
};
export default TipsPage;